module.exports = __webpack_public_path__ + "img/49577506-a5f6-46bf-9aec-11771fc9f160.a73615ab.png";